<template>
    <div>
        <div v-loading="dlgLoading">
            <table class="row" v-for="record in records" :key="record.sn">
                <tr>
                    <td>缴费金额：</td><td>{{record.payAmount}}</td>
                </tr>
                <tr>
                    <td>缴费方式：</td><td>{{record.payTypeStr}}（{{record.chargeStatusStr}}）</td>
                </tr>
                <tr>
                    <td>缴费时间：</td><td>{{record.payTime}}</td>
                </tr>
                <tr>
                    <td>  订单号：</td><td>{{record.sn}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import { get } from "@/assets/common/request";

export default {
    name: "ChargeRecord",
    props: {
        meterId: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            dlgLoading: false,
            records: [],
        }
    },
    methods: {
        loadData() {
            const url = 'meter/web/order/chargeRecord';
            this.dlgLoading = true;
            get(url, {meterId: this.meterId}).then(data => {
                const records = data.data;
                this.records = records;
            }).finally(() => {
                this.dlgLoading = false;
            });
        }
    },
    mounted() {
        if(this.meterId) {
            this.loadData();
        }
    }
}
</script>

<style scoped>
.row {
    margin: 10px 0px; 
    height: 18px;
    line-height: 20px;
    font-size: 14px;
    border: 1px solid #ccc;
}
.row td {
    margin: 10px 5px;
    padding: 5px;
    border: 1px solid #ccc;
    width: 180px
}
</style>